import { render, staticRenderFns } from "./CustomerInquiry.vue?vue&type=template&id=f12ab44e&scoped=true"
import script from "./CustomerInquiry.vue?vue&type=script&lang=js"
export * from "./CustomerInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ab44e",
  null
  
)

export default component.exports